jQuery( document ).ready( function( $ ) {
	const isSingleProductPage = document.querySelector( '.single-product' );

	if ( isSingleProductPage ) {
		$( '.rp-dimensions' ).appendTo( '.woocommerce-product-details__short-description' );
		$( '.rp-sku' ).appendTo( '.woocommerce-product-details__short-description' );
	}
} );
